﻿/* Wizard functions */
"use strict";

window.wizardPrevPage = function (shallDelayForPleaseWaitToShow) {
    // If we use a PleaseWait before moving to the next page (e.g. in bulk import), Firefox will
    // not show the animation because the submit happens immediately after the call to show the PleaseWait.
    // We trick it by waiting a short while and then submitting. Note that reducing the dealy too
    // much does not suffice, so we set it to 50 milliseconds
    const delay = shallDelayForPleaseWaitToShow ? 50 : 0;
    setTimeout(() => {
        doNotWarnOnPageLeave();
        $("#WizardPageCommand").val("prev");
        $("form")[0].submit();
    }, delay);
};

window.wizardNextPage = function (shallDelayForPleaseWaitToShow) {
    // If we use a PleaseWait before moving to the next page (e.g. in bulk import), Firefox will
    // not show the animation because the submit happens immediately after the call to show the PleaseWait.
    // We trick it by waiting a short while and then submitting. Note that reducing the dealy too
    // much does not suffice, so we set it to 50 milliseconds
    const delay = shallDelayForPleaseWaitToShow ? 50 : 0;
    setTimeout(() => {
        if ($("form").valid()) {
            doNotWarnOnPageLeave();
            $("#WizardPageCommand").val("next");
            $("form")[0].submit();
        }
    }, delay);
};